// eslint-disable-next-line no-restricted-globals
export default amount => (isNaN(amount)
	? '' : (amount % 1 === 0
		? amount
		: parseFloat(amount).toFixed(2)))
